// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"e_5d","pageSubTitle":"e_6d"};